import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome, FaLink, FaCog, FaHashtag, FaSignOutAlt, FaUserCircle,
  FaChartBar, FaPlus, FaTasks, FaCoins, FaGavel, FaGift, FaImages,
  FaChevronDown, FaChevronRight, FaBars, FaTimes,
  FaSkull, FaClipboardCheck, FaEye, FaLock, FaScroll,
  FaUser, FaTheaterMasks, FaTshirt, FaMapMarkerAlt,
  FaDumbbell, FaBook, FaFileContract, FaHistory, FaSlidersH,
  FaHeart, FaGamepad,
  FaSun, FaMoon, FaComments, FaBed, FaUtensils, FaBan,
  FaCalendarWeek, FaCalendarAlt, FaShieldAlt, FaBolt,
  FaCubes, FaPlay, FaTrophy, FaClock, FaHandHoldingHeart,
  FaExclamationTriangle, FaListUl
} from 'react-icons/fa';
import { logout } from '../services/api';
import '../styles/Navbar.css';

function Navbar({ user }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Define categories
  const categories = useMemo(() => [
    {
      id: 'main',
      label: 'Hauptmenü',
      icon: <FaHome />,
      items: [
        { path: '/dashboard', label: 'Dashboard', icon: <FaHome /> }
      ]
    },
    {
      id: 'links',
      label: 'Link Sammlung',
      icon: <FaLink />,
      items: [
        { path: '/links', label: 'Links', icon: <FaLink /> },
        { path: '/channels', label: 'Channels', icon: <FaHashtag /> }
      ]
    },
    {
      id: 'counters',
      label: 'Zähler',
      icon: <FaChartBar />,
      items: [
        { path: '/count-config', label: 'Count Config', icon: <FaChartBar /> },
        { path: '/custom-counters', label: 'Custom Counters', icon: <FaPlus /> }
      ]
    },
    {
      id: 'ds-system',
      label: 'D/s System',
      icon: <FaHeart />,
      items: [
        { path: '/tasks', label: 'Aufgaben', icon: <FaTasks /> },
        { path: '/points', label: 'Punkte', icon: <FaCoins /> },
        { path: '/rules', label: 'Regeln', icon: <FaGavel /> },
        { path: '/punishments', label: 'Strafen', icon: <FaSkull /> },
        { path: '/rewards', label: 'Belohnungen', icon: <FaGift /> }
      ]
    },
    {
      id: 'behavior',
      label: 'Verhalten',
      icon: <FaClipboardCheck />,
      items: [
        { path: '/checkins', label: 'Check-Ins', icon: <FaClipboardCheck /> },
        { path: '/inspections', label: 'Inspektionen', icon: <FaEye /> },
        { path: '/control', label: 'Kontrolle', icon: <FaLock /> },
        { path: '/protocols', label: 'Protokolle', icon: <FaScroll /> },
        { path: '/speech-rules', label: 'Sprachregeln', icon: <FaComments /> }
      ]
    },
    {
      id: 'daily',
      label: 'Tagesstruktur',
      icon: <FaSun />,
      items: [
        { path: '/morning-reports', label: 'Morgen', icon: <FaSun /> },
        { path: '/evening-reports', label: 'Abend', icon: <FaMoon /> },
        { path: '/routines', label: 'Routinen', icon: <FaClock /> },
        { path: '/week-planning', label: 'Wochenplan', icon: <FaCalendarWeek /> },
        { path: '/month-planning', label: 'Monatsplan', icon: <FaCalendarAlt /> }
      ]
    },
    {
      id: 'body-control',
      label: 'Körperkontrolle',
      icon: <FaBan />,
      items: [
        { path: '/clothing-rules', label: 'Kleidung', icon: <FaTshirt /> },
        { path: '/grooming', label: 'Pflege', icon: <FaListUl /> },
        { path: '/sleep', label: 'Schlaf', icon: <FaBed /> },
        { path: '/food', label: 'Ernährung', icon: <FaUtensils /> },
        { path: '/orgasm-control', label: 'Orgasmuskontrolle', icon: <FaBan /> },
        { path: '/media-tasks', label: 'Medien-Aufgaben', icon: <FaImages /> }
      ]
    },
    {
      id: 'activities',
      label: 'Aktivitäten',
      icon: <FaBolt />,
      items: [
        { path: '/activity-sessions', label: 'Sessions', icon: <FaBolt /> },
        { path: '/sessions', label: 'Geführte Sessions', icon: <FaPlay /> },
        { path: '/toys', label: 'Spielzeug', icon: <FaCubes /> },
        { path: '/challenges', label: 'Challenges', icon: <FaTrophy /> }
      ]
    },
    {
      id: 'safety',
      label: 'Sicherheit',
      icon: <FaShieldAlt />,
      items: [
        { path: '/safety', label: 'Ampelsystem', icon: <FaShieldAlt /> },
        { path: '/aftercare', label: 'Nachsorge', icon: <FaHandHoldingHeart /> },
        { path: '/limits', label: 'Grenzen', icon: <FaExclamationTriangle /> }
      ]
    },
    {
      id: 'ffxiv',
      label: 'FFXIV',
      icon: <FaGamepad />,
      items: [
        { path: '/characters', label: 'Charaktere', icon: <FaUser /> },
        { path: '/scenes', label: 'Szenen', icon: <FaTheaterMasks /> },
        { path: '/glamours', label: 'Glamours', icon: <FaTshirt /> },
        { path: '/venues', label: 'Orte', icon: <FaMapMarkerAlt /> }
      ]
    },
    {
      id: 'advanced',
      label: 'Erweitert',
      icon: <FaDumbbell />,
      items: [
        { path: '/training', label: 'Training', icon: <FaDumbbell /> },
        { path: '/journals', label: 'Tagebuch', icon: <FaBook /> },
        { path: '/contracts', label: 'Verträge', icon: <FaFileContract /> },
        { path: '/media', label: 'Medien', icon: <FaImages /> }
      ]
    },
    {
      id: 'settings',
      label: 'Einstellungen',
      icon: <FaCog />,
      items: [
        { path: '/activity-log', label: 'Aktivitätslog', icon: <FaHistory /> },
        { path: '/settings', label: 'Einstellungen', icon: <FaSlidersH /> },
        { path: '/commands', label: 'Commands', icon: <FaCog /> }
      ]
    }
  ], []);

  // Find which category contains the current path
  const getActiveCategoryId = (pathname) => {
    for (const cat of categories) {
      if (cat.items.some(item => item.path === pathname)) {
        return cat.id;
      }
    }
    return null;
  };

  const [expandedCategories, setExpandedCategories] = useState(() => {
    const activeCat = getActiveCategoryId(location.pathname);
    return activeCat ? [activeCat] : ['main'];
  });

  // Auto-expand category when navigation changes
  useEffect(() => {
    const activeCat = getActiveCategoryId(location.pathname);
    if (activeCat) {
      setExpandedCategories(prev =>
        prev.includes(activeCat) ? prev : [...prev, activeCat]
      );
    }
  }, [location.pathname, categories]);

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const getAvatarUrl = () => {
    if (!user.avatar) return null;
    return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`;
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev =>
      prev.includes(category)
        ? prev.filter(c => c !== category)
        : [...prev, category]
    );
  };

  const isActive = (path) => location.pathname === path;
  const isCategoryActive = (paths) => paths.some(path => location.pathname === path);

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="sidebar-toggle"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        {/* Brand */}
        <div className="sidebar-brand">
          <span className="brand-icon">🔗</span>
          <span className="brand-text">Link Collector</span>
        </div>

        {/* User Info */}
        <div className="sidebar-user">
          <div className="user-avatar-wrapper">
            {getAvatarUrl() ? (
              <img src={getAvatarUrl()} alt={user.username} className="user-avatar" />
            ) : (
              <FaUserCircle className="user-avatar-icon" />
            )}
            <span className="user-status"></span>
          </div>
          <div className="user-details">
            <span className="username">
              {user.username}
              {user.discriminator && user.discriminator !== '0' && `#${user.discriminator}`}
            </span>
            {user.isAdmin && <span className="admin-badge">ADMIN</span>}
          </div>
        </div>

        {/* Navigation Categories */}
        <div className="sidebar-menu">
          {categories.map(category => (
            <div key={category.id} className="nav-category">
              <button
                className={`category-header ${isCategoryActive(category.items.map(i => i.path)) ? 'has-active' : ''}`}
                onClick={() => toggleCategory(category.id)}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-label">{category.label}</span>
                <span className="category-arrow">
                  {expandedCategories.includes(category.id) ? <FaChevronDown /> : <FaChevronRight />}
                </span>
              </button>

              <div className={`category-items ${expandedCategories.includes(category.id) ? 'expanded' : 'collapsed'}`}>
                {category.items.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                  >
                    <span className="item-icon">{item.icon}</span>
                    <span className="item-label">{item.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Logout Button */}
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt />
            <span>Abmelden</span>
          </button>
        </div>
      </nav>

      {/* Overlay for mobile */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}
    </>
  );
}

export default Navbar;
